<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
        <el-breadcrumb-item>大体积混凝土监测</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="build-bar">
        <p style="border-left: 5px solid #018eed; padding-left: 1vh">
          大体积混凝土结构测温记录
        </p>
        <!-- <el-button
          type="primary"
          icon="el-icon-edit"
          @click="addMac"
        ></el-button> -->
      </div>
      <div class="main-table">
        <el-table
          :data="tableDataEnd"
          height="100%"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
        >
          <template slot="empty">
            <p>{{ dataText }}</p>
          </template>
          <el-table-column
            label="序号"
            type="index"
            width="100"
          ></el-table-column>
          <el-table-column label="编号">
            <template slot-scope="scope">
              <span class="color5" @click="toInfo(scope.row)">{{
                scope.row.mixCoding
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结构部位">
            <template slot-scope="scope">
              <span>{{ scope.row.partName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="砼浇灌日期">
            <template slot-scope="scope">
              <span>{{ scope.row.wateringDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="砼数量（m³）">
            <template slot-scope="scope">
              <span>{{ scope.row.concreteNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="砼强度等级">
            <template slot-scope="scope">
              <span>{{ scope.row.strengthGrade }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="handSet(scope.$index, scope.row)"
                >预警设置</el-button
              >
              <el-button
                size="mini"
                v-if="isMenuExit('pro:elebox:edit')"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-if="isMenuExit('pro:elebox:edit')"
                @click="macDelete(scope.$index, scope.row)"
                >解绑</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增大体积混凝土结构 -->
    <el-dialog width="30%" title="添加混凝土结构" :visible.sync="mixVisible">
      <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        class="add-form"
        width="30%"
        :rules="rules"
      >
        <el-form-item label="结构部位名称：" prop="partName">
          <el-input
            v-model="addForm.partName"
            placeholder="请输入结构部位名称"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="砼强度等级：" prop="strengthGrade">
          <el-input
            v-model="addForm.strengthGrade"
            placeholder="请输入序列号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="配合比编码：">
          <el-input
            v-model="addForm.mixCoding"
            placeholder="请输入配合比编码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="砼数量：" prop="concreteNum">
          <el-input
            v-model="addForm.concreteNum"
            placeholder="请输入砼数量"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="浇灌时间："
          prop="wateringDate"
          style="text-align: left"
        >
          <el-date-picker
            v-model="addForm.wateringDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="浇灌温度：">
          <el-input
            v-model="addForm.wateringTemperature"
            placeholder="请输入浇灌温度"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始养护温度：">
          <el-input
            v-model="addForm.maintenTemperature"
            placeholder="请输入开始养护温度"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="DTU设备：">
          <el-select v-model="addForm.tsDtuId" clearable placeholder="请选择">
            <el-option
              v-for="item in TsDtuList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mixVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 预警弹框 -->
    <el-dialog
      :title="dialogSetTitle"
      :visible.sync="setVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="setForm"
        ref="setForm"
        label-width="150px"
        :label-position="labelPosition"
      >
        <div v-for="(item, index) in type" :key="index">
          <el-form-item :label="item.name">
            <el-input-number
              v-model="item.num"
              :step="1"
              label="描述文字"
            ></el-input-number>
            <span> 度</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitSetRow('setForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 新增窗口 -->
    <!-- <el-dialog
      title="绑定设备列表"
      :visible.sync="addVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="50%"
    >
      <el-dialog
        width="30%"
        title="添加设备"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form
          :model="addForm"
          ref="addForm"
          label-width="150px"
          :label-position="labelPosition"
          style="padding-right: 3vw"
          :rules="rules"
        >
          <el-form-item label="结构部位名称：">
            <el-input
              v-model="macForm.name"
              placeholder="请输入结构部位名称"
              readonly
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择设备：">
            <el-select
              v-model="macForm.concreteId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in concreteList"
                :key="item.id"
                :label="item.concreteName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="addMacFun()">确 定</el-button>
        </div>
      </el-dialog>
      <p style="width: 100%; position: relative; height: 6vh; padding: 0 1vw">
        <el-button type="primary" @click="addDialogMac">添加设备</el-button>
      </p>
      <el-table
        :data="macList"
        height="50vh"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
      >
        <template slot="empty">
          <p>{{ diaText }}</p>
        </template>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.index }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备名称">
          <template slot-scope="scope">
            <span>{{ scope.row.concreteName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备序列号">
          <template slot-scope="scope">
            <span>{{ scope.row.imei }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="macDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog> -->
    <!-- 二维码弹出框 -->
    <!-- <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
            </div>
        </el-dialog> -->
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import vueQr from 'vue-qr'
import base from '../../../untils/base'
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      tableSn: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      groupId: '',
      dataText: '数据加载中...',
      addVis: false,
      dialogTitle: '',
      labelPosition: 'right',
      addForm: {
        id: '',
        projectId: '',
        partName: '',
        strengthGrade: '',
        mixCoding: '',
        concreteNum: '',
        wateringDate: '',
        wateringTemperature: '',
        maintenTemperature: '',
        createBy: '',
        tsDtuId: '',
      },
      dialogSetTitle: '设置预警参数',
      setVisible: false,
      // uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
      // uploadHead1: {
      //     accessToken: util.session.get('token')
      // },
      rules: {
        partName: [
          { required: true, message: '请输入结构部位名称', trigger: 'blur' },
        ],
        strengthGrade: [
          { required: true, message: '请输入砼强度等级', trigger: 'blur' },
        ],
        concreteNum: [
          { required: true, message: '请输入砼数量', trigger: 'blur' },
        ],
        wateringDate: [
          { required: true, message: '请选择浇灌时间', trigger: 'blur' },
        ],
      },
      //二维码
      // codeVis:false,
      // codeUrl:'',
      // codeTit:'',
      // icon:'',//配电箱图
      // http:base.httpCtx
      diaText: '数据加载中...', //
      macList: [], //弹出框table列表
      innerVisible: false,
      mixVisible: false, //大体积混凝土结构- 弹出框
      macForm: {
        name: '',
      },
      concreteProjectId: '', //当前混凝土数据id
      //concreteProjectName:'',//当前混凝土数据名称
      concreteList: [], //混凝土设备列表
      TsDtuList: [], //设备列表
      setForm: {},
      id: '',
      tsDtuId: '',
      type: [
        { name: '上', tsSersorType: '1', num: '0' },
        { name: '中', tsSersorType: '2', num: '0' },
        { name: '下', tsSersorType: '3', num: '0' },
      ],
    }
  },
  mounted() {
    var params = this.$route.params
    this.groupId = params.id
    this.addForm.projectId = params.id
    this.getData()
    this.getMachine()
  },
  methods: {
    getData() {
      var that = this
      myHttp
        .selectConcreteProjectListPage({
          projectId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.PageInfo.total
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
        })
    },
    // 设备列表
    getMachine() {
      var that = this
      myHttp
        .selectTsDtuByList({
          groupId: this.groupId,
          userType: util.session.get('roleId'),
          useType:'1'
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.TsDtuList = resp.data.data.TsDtu || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
        )
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //查询
    doFilter() {
      this.currentPage = 1
      this.getData()
    },

    //添加
    addMac() {
      this.mixVisible = true
      this.addForm.id = ''
      this.addForm.partName = ''
      this.addForm.strengthGrade = ''
      this.addForm.mixCoding = ''
      this.addForm.concreteNum = ''
      this.dialogTitle = '添加'
      this.addForm.wateringDate = util.myTime.getCurTime() + ' 00:00:00'
      this.addForm.wateringTemperature = ''
      this.addForm.maintenTemperature = ''
      this.addForm.tsDtuId = ''
    },
    //编辑
    handleEdit(index, row) {
      this.mixVisible = true
      this.addForm.id = row.id
      this.addForm.partName = row.partName
      this.addForm.strengthGrade = row.strengthGrade
      this.addForm.mixCoding = row.mixCoding
      this.addForm.concreteNum = row.concreteNum
      this.addForm.wateringDate = row.wateringDate
      this.addForm.wateringTemperature = row.wateringTemperature
      this.addForm.tsDtuId = row.tsDtuId
      this.addForm.maintenTemperature = row.maintenTemperature
      this.dialogTitle = '修改'
    },
    //删除
    // handleDelete(index,row){
    //     var that = this
    //     this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //     }).then(() => {
    //         myHttp.delDistribution({
    //             id: row.id,
    //             updateBy:util.session.get('user').id
    //         }).then(function(resp) {
    //             if (resp.data.code == '200') {
    //                 that.$message.success('删除成功')
    //                 that.getData()
    //             } else {
    //                 that.$message.error(resp.data.msg)
    //             }
    //         })
    //     })
    // },
    //提交
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.addForm.id == '') {
            that.addForm.createBy = util.session.get('user').id
            myHttp.postConcreteProject(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.mixVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          } else {
            that.addForm.updateBy = util.session.get('user').id
            myHttp.updateConcreteProject(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.mixVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          }
        }
      })
    },

    //展示二维码
    erCode(index, row) {
      this.codeVis = true
      this.codeUrl = '/pages/equipCheck/equipCheck?snId=' + row.sn
      this.codeTit = row.location
    },

    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      // var flag = util.common.filterBtnMenu(row)
      // return flag
      return true
    },

    /**
     * 获取历史记录
     */
    // history(index,row){
    //     this.$router.push({ path: '/eleBoxHistory/'+row.sn })
    // },
    // 上传图片
    // handleIconSuccess(res, file) {
    // this.icon = URL.createObjectURL(file.raw)
    // console.log(res.data)
    // this.addForm.photoUrl = res.data.savePhotoUrls
    // this.addForm.thumbnailUrl =res.data.saveThumbnailUrls
    // },
    toInfo(row) {
      this.$router.push({ path: '/mixedInfoEnt/' + row.id+'/'+this.groupId })
    },
    /**
     * 绑定设备
     */
    macListAdd(index, row) {
      var that = this
      this.addVis = true
      this.concreteProjectId = row.id
      this.macForm.name = row.partName
      myHttp
        .selectConcreteListByProjectId2({
          projectId: this.groupId,
          concreteProjectId: row.id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Concrete || []
            that.macList = list
            if (list.length == 0) {
              that.diaText = '暂无数据'
            }
          } else {
            that.diaText = '暂无数据'
          }
        })
    },
    /**
     * 刷新绑定设备
     */
    refreshMac(id) {
      var that = this
      myHttp
        .selectConcreteListByProjectId2({
          projectId: this.groupId,
          concreteProjectId: id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Concrete || []
            that.macList = list
            if (list.length == 0) {
              that.diaText = '暂无数据'
            }
          } else {
            that.diaText = '暂无数据'
          }
        })
    },
    /**
     * 设备添加
     */
    addDialogMac() {
      this.innerVisible = true
      var that = this
      myHttp
        .selectConcreteListByProjectId({
          projectId: this.groupId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Concrete || []
            that.concreteList = list
          }
        })
    },
    /**
     * 提交绑定设备
     */
    addMacFun() {
      var that = this
      myHttp
        .bindingEquipConcrete({
          concreteProjectId: this.concreteProjectId,
          id: this.macForm.concreteId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.innerVisible = false
            that.refreshMac(that.concreteProjectId)
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    /**
     * 解除设备
     */
    macDelete(index, row) {
      var that = this
      if (!row.tsDtuSensorId) {
        that.$message.success('该设备已解绑')
        return
      }
      this.$confirm('此操作将解除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        myHttp
          .unbundlingTsDtuSensorDTU({
            id: row.tsDtuSensorId,
            updateBy: util.session.get('user').id,
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.refreshMac(that.concreteProjectId)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
    handSet(index, row) {
      console.log(index)
      this.setVisible = true
      this.id = row.tsDtuSensorId
      this.tsDtuId = row.id
    this.bundlingTsDtuSensorDTU(index)
    },
    // 预警值回显
    bundlingTsDtuSensorDTU(index) {
      var that = this
      console.log(this.tsDtuId)
      // myHttp
      //   .bundlingTsDtuSensorDTU({
      //     useId: this.tsDtuId,
      //   })
      //   .then(function (resp) {
      //     // console.log(resp)
      //     if (resp.data.code == '200') {
            console.log(this.tableDataEnd[index].warning)
            var data =this.tableDataEnd[index].warning
            if (data != 'null' && data != null ) {
              that.type = JSON.parse(data)
            }
      //     }
      //   })

    },
    // 设置预警值
    sumbitSetRow(formName) {
      var that = this
      // console.log(that.addForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id == '') {
            that.$message.error('请先绑定设备')
            return
          }
          let setFormarry = that.type
          setFormarry = JSON.stringify(setFormarry)
          myHttp
            .warningDTU({
              id: this.id,
              jsonString: setFormarry,
            })
            .then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('设置成功')
                  that.setVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          // }
        }
      })
    },
  },
}
</script>

<style scoped>
.main {
  flex-wrap: wrap;
  align-content: flex-start;
}
.main-table {
  width: 100%;
  height: calc(100% - 11.4vh);
}
.build-bar {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6vh;
  border-bottom: 3px solid #17b2fe;
  background: #fff;
  justify-content: space-between;
  padding: 0 1vw;
}

.build-bar span {
  margin-left: 30px;
  white-space: nowrap;
  display: inline-block;
}

.build-bar > .el-input {
  width: 200px;
  font-size: 12px;
}
.build-bar > .el-button {
  margin-left: 30px;
  /* background-color: #17b2fe;
        border-color: #17b2fe; */
}
.erCode {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.avatar {
  width: 100%;
}
.dialog-footer{
  text-align: center;
}
</style>

<style>
@import '../../../assets/css/common.css';
</style>